import { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { NoticeEmpty } from '@components/UI/Notice'
import { SHORTLISTED_FILTER } from '@constants'
import { Container } from '@tribegroup'

interface IProps {
  submissionFilter: string
  isUnlocked: boolean
  isSocialCampaign?: boolean
}

const SubmissionCardListEmptyDefault: FC<IProps> = ({
  submissionFilter,
  isUnlocked,
  isSocialCampaign,
}) => {
  let title = `inbox.cardlist.empty.title.${submissionFilter}`
  let subtitle = `inbox.cardlist.empty.subtitle.${submissionFilter}`

  if (submissionFilter === SHORTLISTED_FILTER) {
    if (!isSocialCampaign) {
      title = `${title}.contentCampaign`
      subtitle = `${subtitle}.contentCampaign`
    } else if (isUnlocked) {
      title = `${title}.unlocked`
      subtitle = `${subtitle}.unlocked`
    }
  }

  return (
    <NoticeEmpty
      alt="submission"
      title={
        <Container maxWidth={22.75}>
          <FormattedMessage id={title} />
        </Container>
      }
      subtitle={<FormattedMessage id={subtitle} />}
    />
  )
}

export default SubmissionCardListEmptyDefault
